/** @jsx jsx */
import {PropTypes} from 'prop-types'
import {jsx} from '@emotion/react'
import Uninstall4624 from '../components/templates/sp-4624/uninstall/uninstall-4624'

const UninstallPage = ({languageCode}) => {
    return <Uninstall4624 languageCode={languageCode} />
}

UninstallPage.propTypes = {
    languageCode: PropTypes.string,
}

UninstallPage.defaultProps = {
    languageCode: `en`,
}

export default UninstallPage
